import { render, staticRenderFns } from "./AddressinformationForm.vue?vue&type=template&id=5952c2b0&"
import script from "./AddressinformationForm.vue?vue&type=script&lang=js&"
export * from "./AddressinformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports